<h2>Media dev screen</h2>


<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>Media library control</mat-panel-title>
    <mat-panel-description></mat-panel-description>
  </mat-expansion-panel-header>
  <form [formGroup]="form">
    <div>
      <div>Image</div>
      <media-control formControlName="image"></media-control>
    </div>
  
    <div>
      <div>Image A</div>
      <media-control formControlName="imageA"></media-control>
    </div>
  </form>
  <hr/>
  <h4>Form values</h4>
  {{ form.value | json }}
  {{ form.errors | json }}
  <hr />  
</mat-expansion-panel>


<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>Media library component</mat-panel-title>
  </mat-expansion-panel-header>
  <media-library></media-library>
</mat-expansion-panel>

<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>Media Library dialog</mat-panel-title>
  </mat-expansion-panel-header>
  <button (click)="openMediaLibraryDialog()">Open library</button>
</mat-expansion-panel>

<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>Media Upload component</mat-panel-title>
  </mat-expansion-panel-header>
  <media-upload></media-upload>
</mat-expansion-panel>

<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>Image component - thumbnail</mat-panel-title>
  </mat-expansion-panel-header>
  <media-image [imageId]="imageAId" mode="thumbnail"/>
</mat-expansion-panel>

<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>Image component - original</mat-panel-title>
  </mat-expansion-panel-header>
  <media-image [imageId]="imageAId" variant="original"/>
</mat-expansion-panel>